import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'negativeNumber', standalone: false
})
export class NegativeNumberPipe implements PipeTransform {
    transform(value: any, prefix?: string, suffix?: string, force?: boolean): string {
      if(value !== null) {
        value = value.toString();
        
        force = (typeof force === "undefined") ? false : force;
        prefix = (typeof prefix === "undefined") ? "" : prefix;
        suffix = (typeof suffix === "undefined") ? "" : suffix;

        if(value.charAt(0) === '-') {
          return '(' + prefix + value.substring(1, value.length) + suffix + ')';
        } else if(force) {
          return '(' + prefix + value + suffix + ')';
        }

        return prefix + value + suffix;
      } else {
        return "";
      }
    }
}
